/**
 * set cookie
 * @param {string} key
 * @param {string} value
 * @param {object} attributes
 */
var setCookie = function (key, value, attributes) {
  attributes = Object.assign({
    path: '/'
  }, attributes);

  if (typeof attributes.expires === 'number') {
    var expires = new Date();
    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e5);
    attributes.expires = expires;
  } // We're using "expires" because "max-age" is not supported by IE


  attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }

  value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
  key = encodeURIComponent(String(key));
  key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
  key = key.replace(/[\(\)]/g, escape);
  var stringifiedAttributes = '';

  for (var attributeName in attributes) {
    if (!attributes[attributeName]) {
      continue;
    }

    stringifiedAttributes += "; " + attributeName;

    if (attributes[attributeName] === true) {
      continue;
    }

    stringifiedAttributes += "=" + attributes[attributeName];
  }

  return document.cookie = key + "=" + value + stringifiedAttributes;
};
/**
 * get cookie
 * @param {string} key , the key of cookie , if not set, will return all the cookie
 */


var getCookie = function (key, options) {
  if (options === void 0) {
    options = {};
  }

  var result = key ? null : {};
  var cookies = document.cookie ? document.cookie.split('; ') : [];
  var rdecode = /(%[0-9A-Z]{2})+/g;

  for (var i = 0; i < cookies.length; i++) {
    var parts = cookies[i].split('=');
    var cookie = parts.slice(1).join('=');

    if (!options.json && cookie.charAt(0) === '"') {
      cookie = cookie.slice(1, -1);
    }

    try {
      var name = parts[0].replace(rdecode, decodeURIComponent);
      cookie = cookie.replace(rdecode, decodeURIComponent);

      if (options.json) {
        try {
          cookie = JSON.parse(cookie);
        } catch (e) {}
      }

      if (key === name) {
        result = cookie;
        break;
      }

      if (!key) {
        result[name] = cookie;
      }
    } catch (e) {}
  }

  return result;
};
/**
 * remove the cookie
 * @param {string} key
 * @param {object} attributes
 */


var removeCookie = function (key, attributes) {
  if (attributes === void 0) {
    attributes = {};
  }

  setCookie(key, '', Object.assign(attributes, {
    expires: -1
  }));
};

export { getCookie, setCookie, removeCookie };